var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('audio-player-bar'),(_vm.isShowPayDialog)?_c('Pay',{attrs:{"payType":_vm.payType,"lessionOrAudioBookId":_vm.lessionOrAudioBookId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }